export const listItemInit = {
    id: '-1',
    title: ''
};

export const cityInit = {
    id: '-1',
    city: '',
    state_id: '-1',
    state: '',
    state_code: '',
};

export const countryStateInit = {
    id: -1,
    state: '',
    state_code: '',
};

export const countryInit = {
    id: -1,
    code: '',
    title: '',
};